import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const useStyles = makeStyles((theme) => ({
  signifierContainer: {
    position: "absolute",
    top: 50,
    left: "50%",
    transform: "translate(-50%, 0)",
    zIndex: 1400, // Above modal backdrops
    animation: `$scrollIn 4000ms forwards`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  root: {
    [theme.breakpoints.down("sm")]: {
      minWidth: "80vw",
      maxHeight: "20px",
    },
    minWidth: 600,
    position: "relative",

    left: "50%",
    transform: "translate(-50%, 0)",

    display: "flex",
    alignItems: "center",
    padding: "0.5em 1em",
    "& .MuiCardContent-root:last-child": {
      paddingBottom: "0.5em",
    },
  },
  hidden: {
    display: "none",
  },
  title: {
    fontSize: 26,
    animation: "none !important",
  },
  "@keyframes scrollIn": {
    "0%": {
      top: -200,
    },
    "20%": {
      top: 50,
    },
    "80%": {
      top: 50,
    },
    "100%": {
      top: -200,
    },
  },
}));

export default function Signifier({ showSignifier, setShowSignifier, message, error, errorMessage }) {
  const classes = useStyles();

  return (
    <span
      className={showSignifier ? classes.signifierContainer : classes.hidden}
      onAnimationEnd={() => setShowSignifier(false)}
    >
      <Card className={showSignifier ? classes.root : classes.hidden} variant="outlined">
        <CardContent className={classes.root}>
          <span className={classes.title}>
            {!error ? message : errorMessage !== undefined ? errorMessage : "Something went wrong"}
          </span>
        </CardContent>
      </Card>
    </span>
  );
}
